/**
 * Scrollspy behaviour.
 */

(function (Drupal, $, gumshoe) {
  "use strict";

  Drupal = Drupal || {};

  Formstone.NoConflict();
  
  /**
   * JS Behaviour.
   *
   * @type {{attach: Drupal.behaviors.scrollspy.attach}}
   */
  Drupal.behaviors.scrollspy = {
    attach: function (context, settings) {
      $('[data-scrollspy]').once('gumshoe', function (e) {
        gumshoe.init({
          selector: '[data-scrollspy] a',
          container: window,
          offset: $('[data-scrollspy]').attr('data-scrollspy-container-offset') || 0,
        });
      });
    }
  }

})(Drupal, jQuery, gumshoe);
